import { getBrand } from './brand/index.js'

const isProd = import.meta.env.PROD
const { sentryDsn, apiHost } = getBrand().monitoring

if (isProd && sentryDsn) {
  import('@sentry/react').then((Sentry) => {
    Sentry.init({
      dsn: sentryDsn,
      sendDefaultPii: true,
      integrations: [
        Sentry.browserTracingIntegration(),
      ],
      tracesSampleRate: 0.15,
      // Same-origin always; the brand's API host only when it declares one, so
      // a brand without monitoring never propagates tracing headers to a domain
      // that is not its own.
      tracePropagationTargets: apiHost
        ? [/^\//, new RegExp(`^https://${apiHost.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/api`)]
        : [/^\//],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })

    // Lazy-load Replay after Sentry is initialized (heavy: ~300KB)
    Sentry.lazyLoadIntegration('replayIntegration').then((replay) => {
      Sentry.addIntegration(replay())
    })
  })
}
